//
//
//
//
//
//
//
//

export default {
    props: {
        id: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isActive: false,
            isNext: false,
            isPrev: false,
            isLoaded: false,
        };
    },
    computed: {
        /** @return {boolean} */
        display() {
            const parent = /** @type {any} */(this.$parent);
            if (!parent.renderAll) {
                return this.isActive;
            }
            if (!parent.prerenderAll) {
                return this.isActive || this.isLoaded;
            }
            return true;
        },
        /** @return {string} */
        transition() {
            if (this.isNext) {
                return 'fade-in-right';
            } else if (this.isPrev) {
                return 'fade-in-left';
            } else {
                return 'no-transition';
            }
        },
        /** @return {string} */
        unique() {
            return this.id ? this.id : this.name.toLowerCase().replace(/ /g, '-');
        },
        /** @return {string} */
        hash() {
            return '#' + this.unique;
        },
    },
    watch: {
        /** @type {import('vue').WatchHandler<boolean>} */
        isActive(val, oldVal) {
            if (val) {
                /**
                 * Triggered after active tab changes.
                 * Passed an object with `onFocus`, `onBlur` and `onFirstLoad` optional properties.
                 */
                this.$emit('changed', { onFocus: true, onFirstLoad: !this.isLoaded });
                this.isLoaded = true;
            } else if (oldVal && !val) {
                this.$emit('changed', { onBlur: true });
            }
        },
    },
    created() {
        if (this.$parent) {
            // @ts-ignore
            this.$parent.addTab(this);
        }
    },
};
